import { render, staticRenderFns } from "./Format.vue?vue&type=template&id=0f5c3e2d&"
import script from "./Format.vue?vue&type=script&lang=js&"
export * from "./Format.vue?vue&type=script&lang=js&"
import style0 from "./Format.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports